import {actionCreators as errorActionCreators} from '../../actions/errorActions';

function createStorefrontReduxErrorHandler(onError) {
  return function storefrontReduxErrorHandler(error, getState, lastAction, dispatch) {

    if (onError) {
      onError(error, getState, lastAction);
    }

    dispatch(errorActionCreators.reduxErrorOccurred(error, lastAction));
  }
}

export default createStorefrontReduxErrorHandler;
